import { articleTimestampFormat } from "@src/app/util/constant";
import { getFormattedTime } from "@src/app/util/helpers";
import dayjs from "dayjs";

export type ArticleTimeStampProps = {
  publishedDate: string;
  updatedDate: string;
  hasUpdatedTimeDisplayed?: boolean;
};

export default function ArticleTimeStamp({
  publishedDate,
  updatedDate,
  hasUpdatedTimeDisplayed = false,
}: ArticleTimeStampProps): React.ReactElement {
  const updatedTimeAgoInHours = dayjs().diff(publishedDate, "hours");

  return (
    <div className="font-public-sans text-xs font-normal text-gray-650">
      <span data-testid="article-published-time">
        Published {getFormattedTime(publishedDate, articleTimestampFormat)}
      </span>

      {hasUpdatedTimeDisplayed && updatedTimeAgoInHours < 24 ? (
        <span
          className="ml-1 border-l border-gray-650 pl-2 md:ml-2"
          data-testid="article-updated-time"
        >
          Updated {getFormattedTime(updatedDate, articleTimestampFormat)}
        </span>
      ) : null}
    </div>
  );
}
